import { ChangeDetectionStrategy, Component, computed, input, output, signal } from "@angular/core";
import { EvTooltipModule } from "ev-tooltip";
import { EvKeyValuePairModule } from "ev-key-value-pair";
import { ClickOutsideDirective } from "ev-directives";

export interface KeyValuePair<T = string | number | null | undefined> {
    key: string;
    value: T;
    tooltip?: string;
    postfix?: string;
    isOverridden?: boolean;
    newValue?: T;
}

@Component({
    selector: "key-value-pair-list",
    templateUrl: "./key-value-pair-list.component.html",
    styleUrl: "./key-value-pair-list.component.scss",
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [EvTooltipModule, EvKeyValuePairModule, ClickOutsideDirective],
})
export class KeyValuePairListComponent {
    title = input<string | undefined>();
    keyValuePairs = input.required<KeyValuePair[]>();
    enableShowMore = input<boolean>(false);
    showMoreKeyinfo = output<void>();

    showTooltip = computed(() => new Array(this.keyValuePairs().length).fill(false));

    showMore(): void {
        this.showMoreKeyinfo.emit();
    }

    onTooltipToggle(index: number): void {
        const state = this.showTooltip();
        state[index] = !state[index];
    }

    onTooltipClose(index: number): void {
        const state = this.showTooltip();
        state[index] = false;
    }

    onTooltipKeydown(event: KeyboardEvent, index: number): void {
        const key = event.key;
        if (key === "Enter" || key === " ") {
            event.preventDefault();
            this.onTooltipToggle(index);
        } else if (key === "Escape") {
            this.onTooltipClose(index);
        }
    }
}
